import React from 'react'
import SalesReports from '../components/reports/SalesReports'
import {HiOutlineDocumentReport} from 'react-icons/hi'
import { useTranslation } from 'react-i18next'

const Reports = () => {
    const [t,i18n ] = useTranslation('global')
        const isRTL = i18n.dir() === 'rtl';
    return (
        <div className='flex flex-col  '>
            {/* <div className='flex-1 flex gap-1 items-center font-bold text-slate-400'>
                <HiOutlineDocumentReport size={18}/>
                <span>{t('menu.Reports')}</span>
            </div> */}
            <SalesReports/>
        </div>
    )
}

export default Reports